<kendo-formfield>
  <kendo-label *ngIf="label" [text]="label"></kendo-label>
  <kendo-dropdownlist
    [data]="departmentList"
    [valuePrimitive]="true"
    fillMode="outline"
    textField="name"
    valueField="id"
    [ngModel]="selectedId"
    (ngModelChange)="onValueChange($event)"
    [defaultItem]="{ name: placeholder, id: null }"
    [popupSettings]="{ appendTo: 'component', animate: false }"
  >
    <ng-template kendoDropDownListValueTemplate let-dataItem>
      <span [ngClass]="dataItem?.id ? 'not-placeholder' : 'placeholder'">
        {{ dataItem?.id ? (dataItem.id + ' -- ' + dataItem.name) : dataItem?.name }}
      </span>
    </ng-template>
    <ng-template kendoDropDownListItemTemplate let-dataItem>
      <span [ngClass]="dataItem?.id ? 'not-placeholder' : 'placeholder'">
        {{ dataItem?.id ? (dataItem.id + ' -- ' + dataItem.name) : dataItem?.name }}
      </span>
    </ng-template>
  </kendo-dropdownlist>
</kendo-formfield>
